import React, { Component } from "react";
import AuthenticationActionCreator from "../controller/action/AuthenticationActionCreator";
import LoadingComponent from "./utils/LoadingComponent";

interface PropsInterface {
    token: string
    restaurantID: string
    name: string
    locationId: string
}

export default class LoadingContainer extends Component {

    public props: PropsInterface

    constructor(props: any) {
        super(props);
        this.props = props;
    }

    componentDidMount() {
        AuthenticationActionCreator.loginWithRestaurantToken(this.props.token, this.props.restaurantID, this.props.name, this.props.locationId).then(() => {
            (this.props as any).history.push('/home');
        }).catch((err) => {
            console.warn(err);
            (this.props as any).history.push('/login');
        })

        // localhost:3000/login/uQkufPgFgVVEkhodWSoEJcgn3SAPdePb7mtZHs90dVRXWfBDifMdwAaup4C4utJP/1047/BRASSERIE%20TEST%20POPINA/29de6690-9510-4a4e-a71d-f95b1ed84211
    }

    componentWillUnmount() {

    }

    render() {
        return(
            <div style={{ width: '100%', height: '100%' }}>
                <LoadingComponent isOpen={true}/>
            </div>
        );
    }
}